<template>
  <div id="messages" class="messages">
    <transition-group name="slide" mode="out-in" tag="ul">
      <li v-for="message in getMessages"
          class="message"
          :class="message.type"
          :key="message.uid">
        <p>{{ message.title }}</p>
        <button v-if="message.close"
                href="#"
                class="close"
                @click.prevent="removeMessage(message.uid)"
        >X</button>
      </li>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'MessageArea',
  computed: {
    getMessages() {
      return this.$store.state.messages;
    },
  },
  methods: {
    removeMessage(uid) {
      this.$store.commit('removeMessage', uid);
    },
  },
};

</script>

<style scoped>
  .messages {
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 80px;
    display: inline-flex;
    padding: 0 20px;
    overflow: hidden;
    z-index: 9000;
  }

  .messages > ul {
    width: 100% !important;
    padding: 0;
    list-style: none;
  }

  .messages > ul > li {
    width: 100%;
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: white;
    border-radius: 20px;
    margin-bottom: 10px;
    padding: 2px 5px 2px 10px;
    overflow: hidden;
  }
  .messages > ul > li.success {
    background-color: var(--color-success);
    color: white;
  }
  .messages > ul > li.error {
    background-color: var(--color-error);
    color: white;
  }

  .messages > ul > li > p {
    margin: 0;
    padding: 10px;
    width: 100%;
    text-align: left;
  }

  .messages > ul > li > .close {
    width: 30px;
    height: 30px;
    overflow: hidden;
    font-size: .8rem;
    font-weight: bold;
    border-radius: 15px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    background-color: var(--color-dashboard);
    border: 0;
    cursor: pointer;
    padding: 0;
    margin: 0;
  }
  .messages > ul > li.success > .close {
    background-color: var(--color-success-dark);
    color: var(--color-success);
  }
  .messages > ul > li.error > .close {
    background-color: var(--color-error-dark);
    color: var(--color-error);
  }

  .message-area-wrapper:before {
    content: "";
    display: block;
    width: 120%;
    height: 100%;
    background-color: var(--color-primary-ligth);
    position: absolute;
    animation: fetchProgress 1.8s infinite linear;
  }
</style>
